import { type ExpenseMileageConfigurationTaxTypeEnum } from '@webapp/modules/expense/entities/enums'
import {
  MileageRatePreset,
  type MileageRatePresetConstructor,
} from '../MileageRatePreset'

export interface ExpenseMileageConfigurationConstructor {
  forcePresetRates: boolean
  taxType: ExpenseMileageConfigurationTaxTypeEnum
  defaultMileagePreset: Nullable<MileageRatePresetConstructor>
}

export class ExpenseMileageConfiguration {
  readonly forcePresetRates: boolean
  readonly taxType: ExpenseMileageConfigurationTaxTypeEnum
  readonly defaultMileagePreset: Nullable<MileageRatePreset>

  constructor(data: ExpenseMileageConfigurationConstructor) {
    this.forcePresetRates = data.forcePresetRates
    this.taxType = data.taxType
    this.defaultMileagePreset = data.defaultMileagePreset
      ? new MileageRatePreset(data.defaultMileagePreset)
      : null
  }
}
